import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Row, Col } from 'reactstrap';
import { FormattedMessage } from 'react-intl';

import { Icon } from 'react-icons-kit';
import { image } from 'react-icons-kit/fa/image';
import { arrowUp } from 'react-icons-kit/fa/arrowUp';
import { users } from 'react-icons-kit/fa/users';
import { phone } from 'react-icons-kit/fa/phone';
import { car } from 'react-icons-kit/fa/car';

import Link from 'components/Link';

import Form from '../PhoneForm';
import s from './Hero.css';

const Hero = () => (
  <Row className={s.root}>
    <Col md="6" xs="12">
      <h1 className={`h2 ${s.h2}`}>
        <FormattedMessage
          id="sell_auto.hero.heading.1"
          defaultMessage="Продати авто на"
          description=""
        />{' '}
        <strong>Автопрод</strong> -{' '}
        <FormattedMessage
          id="sell_auto.hero.heading.2"
          defaultMessage="просто"
          description=""
        />
        !
      </h1>
      <div className={s.main_item}>
        <FormattedMessage
          id="sell_auto.hero.heading.descr"
          defaultMessage="Безкоштовне розміщення оголошень"
          description=""
        />
        *
      </div>
      <div className="d-none d-md-block">
        <Link to="/cars">
          <div className={s.item}>
            <Icon icon={car} size={40} />{' '}
            <FormattedMessage
              id="sell_auto.hero.heading.feature1"
              defaultMessage="Оголошення реальних продавців"
              description=""
            />
          </div>
        </Link>
        <div className={s.item}>
          <Icon icon={image} size={40} />{' '}
          <FormattedMessage
            id="sell_auto.hero.heading.feature2"
            defaultMessage="Каталог модифікацій при розміщенні"
            description=""
          />
        </div>
        <div className={s.item}>
          <Icon icon={arrowUp} size={40} />{' '}
          <FormattedMessage
            id="sell_auto.hero.heading.feature3"
            defaultMessage="Можливості просування"
            description=""
          />
        </div>
        <div className={s.item}>
          <Icon icon={users} size={40} />{' '}
          <FormattedMessage
            id="sell_auto.hero.heading.feature4"
            defaultMessage="Персональний менеджер"
            description=""
          />
        </div>
        <div className={s.item}>
          <Icon icon={phone} size={40} />{' '}
          <FormattedMessage
            id="sell_auto.hero.heading.feature5"
            defaultMessage="Дзвінки від реальних покупців"
            description=""
          />
        </div>
      </div>
    </Col>
    <Col md="6" xs="12">
      <Form />
    </Col>
  </Row>
);

export default withStyles(s)(Hero);
